'use client'
import React, { ReactNode, useEffect, useState } from "react";
// import './DynamicForm.scss'
import { StyledForm } from "@/shared/StyledComponents";
import { submitForm } from "@/actions/form.action";
import classNames from "classnames";
import { setPropsStyle } from "@/helpers/css.helper";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
// import { CaptchaJs } from "@solarwinter/captchajs";
// import { CAPTCHAS_CLIENT, CAPTCHAS_SECRET } from "@/config/app.config";
import { T_KeyValue } from "@/types/app.type";
// import { useFormStatus } from "react-dom";
import { z } from "zod";
import { useParams } from "next/navigation";
import { getLocale, NODE_ENV } from "@/config/app.config";
import Spinner from "../Spinner";
import { Box } from "@/layouts/LayoutComponents";
import { Body, Heading } from "@/client/foundations/Typography";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { useFormContext } from "@/context/FormContextProvider";
import { useRef } from "react";
import { sendEventToGTM } from "@/helpers/gtm.helper";
import Cookies from "js-cookie";
import { T_DynamicFormProps } from "@/types/form.type";


const formSchema = z.object({

})

/**
 * Name: Form
 * 
 * Description: a function component that receives form CT data and invokes RenderHtml function component to render all child elements inside the form component
 * 
 * @param param0 object containing children, data and other props
 * @example parameter breakdown 
 * ```
 *  param0 : {
 *    id: "",
 *    children,
 *    data: {},   // used to capture data required for form details and rendering children inputs/ buttons
 *  }
 * ```
 * @example T_Props 
 * ```
 * type T_Props = {
 *     id?: string,           // optional
 *     className?: string,    // optional
 *     data?: any,            // optional
 *     typeid?: string,       // optional
 *     children?: ReactNode   // optional
 * }
 * ```
 * @returns a form component containing child elements to be displayed within it
 */
const Form = ({ id, title, api, customApi, className = "", frmData, formContent, successContent, customSuccessContent = false, responseMessages = {}, scroll = false, scrollOnSubmit = true, attachment = null, ...props }: T_DynamicFormProps) => {
   const gtmPushTimeout = useRef<NodeJS.Timeout | null>(null);
   const elData = frmData; //useContentfulLiveUpdates(frmData);
   // const inspectorModeProps = useContentfulInspectorMode();
   // const { pending, data, method, action } = useFormStatus();
   const params = useParams()
   const { ctxFormData, updateCtxFormData, ctxFormSchema } = useFormContext()
   const locale = (Cookies.get("NEXT_LOCALE") || params?.locale || getLocale()) as string;

   // const [emailReq, setEmailReq] = useState({ recipient: data?.content?.recipient });
   // const [inputData, setInputData] = useState({});
   const [submitted, setSubmitted] = useState<boolean>(false)
   const [message, setMessage] = useState<T_KeyValue | null>(null);
   // const [message, setMessage] = useState<{[key: string]: string | boolean} | null>(null)
   // const [imageUrl, setImageUrl] = useState('');
   // const [audioUrl, setAudioUrl] = useState('');
   // const [randomString, setRandomString] = useState('');
   const [count, setCount] = useState(0);
   const [fData, setFData] = useState<any>(null);
   const [formId, setFormId] = useState<string>("");
   const [formSuccessParam, setFormSuccessParam] = useState<string>("");
   const [hideForm, setHideForm] = useState<boolean>(false);
   const [apiName, setApiName] = useState<string>((api === "customApi" ? customApi : api) || "");
   const [apiData, setApiData] = useState();


   useEffect(() => {
      const frmId = (id || apiName);
      console.log("Inside useEffect -------- 1 ", ((id || `form_${frmId}`) + "_form_status"), sessionStorage?.getItem(((id || `form_${frmId}`) + "_form_status")), typeof (sessionStorage?.getItem(((id || `form_${frmId}`) + "_form_status"))), " === ", "Success", sessionStorage?.getItem(((id || `form_${frmId}`) + "_form_status")) === "Success")
      if (sessionStorage?.getItem(((id || `form_${frmId}`) + "_form_status")) === "Success") {
         console.log("Inside useEffect -------- 2 ")
         setMessage({ text: (JSON.parse(sessionStorage?.getItem((id || `form_${frmId}`) + "_form_status_success_message") || "{}") || responseMessages?.["200"]?.[locale]), error: false });
         console.log("Inside useEffect -------- 3 ", { text: (JSON.parse(sessionStorage?.getItem((id || `form_${frmId}`) + "_form_status_success_message") || "{}") || responseMessages?.["200"]?.[locale]), error: false })
      }
      setHideForm(false);
      setApiName((api === "customApi" ? customApi : api) || "");

      setCount(Number(sessionStorage?.getItem(((id || `form_${frmId}`) + "_form_status_count"))) || 0)
      // setFormId((id || ((new Date())?.getTime() + "-thankYou")));
      setFormId(frmId);
      setFormSuccessParam(id || "thankYou");
   }, [])

   useEffect(() => {
      setFData(ctxFormData);        //Redundant
   }, [ctxFormData])

   const scrollToFirstError = () => {
      const firstError = document.querySelector(
         '.bp-form-error, [aria-invalid="true"], [data-error="true"]'
      ) as HTMLElement | null;

      if (firstError) {
         firstError.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
         });

         firstError.focus({ preventScroll: true }); // Focus without jumping
      }
   };

   // const  addBookingReservationNumberToCookies = ({reservation_id, site_id}: {reservation_id: string, site_id: string}) => {
   //    const bookingReservationKey = `reservation_number`;
   //    if (!reservation_id || !site_id) return;

   //    const reservationNumber = `${reservation_id}-${site_id}`;        // store the latest reservation number and ignore previous ones
   //    Cookies.set(bookingReservationKey, reservationNumber, { expires: 30, sameSite: 'lax', secure: true,})
   // }

   // Handle Submit calls the email api to send the user response
   const handleSubmit = async (e: React.FormEvent<HTMLFormElement | null>) => {
      //debugger
      e.preventDefault();
      setMessage(null);

      if (typeof window !== "undefined" && scrollOnSubmit) {
         const element = document.getElementById(formId);
         setHideForm(element?.closest(".bp-modal") ? true : false);           // Redundant
         const headerOffset = 200;
         const elementPosition = element?.getBoundingClientRect().top || 0;
         const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
         window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
         });
      }

      // document?.getElementById(formId)?.scrollIntoView({ behavior: "smooth", block: 'start' });
      const CRLFregex = /(\r\n|\n|\r)/gm;
      if (api && api !== "select") {
         if (api === "customApi") {
            setApiName(customApi || "");
         }

         setSubmitted(true);
         const fData = new FormData(e.currentTarget);
         const fValues = Object.fromEntries(fData);
         console.log(fData, fValues, "CHekcingdfd");
         // return;

         // ----------------- this can be replaced by the API logic ---------------
         fValues.message = String(fValues?.message)?.replace(CRLFregex, '');
         setFData(fValues);   //redundant
         // ----------------------------------------------------------------------

         updateCtxFormData({ formName: apiName, data: fValues })
         //honeypot: check for value
         if (fData?.get('hCal')) {
            if (count >= 0 && count < (["development", "dev"].includes(NODE_ENV) ? 50 : 3)) { // form test
               setMessage({ text: responseMessages?.["200"]?.[locale], error: false });
               sessionStorage?.setItem(((id || `form_${formId}`) + "_form_status_success_message"), JSON.stringify(responseMessages?.["200"]?.[locale] || {}));
            }
            else {
               setMessage({
                  error: true, text: responseMessages?.multipleSubmit?.[locale] || "Invalid submission! You can't submit a form multiple times."
               });
            }
            if (!["development", "dev"].includes(NODE_ENV)) {
               if (typeof window !== "undefined") {
                  sessionStorage?.setItem(((id || `form_${formId}`) + "_form_status"), "Success"); // form test
               }
            }

            if (typeof window !== "undefined") {
               window.location.hash = `#${formSuccessParam}`;
            }

            const newCount = count + 1;
            setCount(newCount);
            if (typeof window !== "undefined") {
               sessionStorage?.setItem(((id || `form_${formId}`) + "_form_status_count"), String(newCount));
            }
            setSubmitted(false);

            setTimeout(() => {
               document?.getElementById("thankYouMsg")?.scrollIntoView({ behavior: "smooth", block: 'center', });
               document?.getElementById('formErrorMsg')?.scrollIntoView({ behavior: "smooth", block: 'center', });
            }, 500)
            // report as bot submission for tracking
            // early return and finish this task
            return;
         }
         let resp: T_KeyValue = { success: true };
         if ((resp?.success && count >= 0 && count < (["development", "dev"].includes(NODE_ENV) ? 50 : 3))) { // form test
            // if ((resp?.success && count > 1) || count <= 1) {
            // if (count > 1) {
            //    setSubmitted('Captcha Verified and Form Submitted!');
            // }
            // else {
            //    setSubmitted('Form Submitted!');
            // }

            // const mailResp = {ok: true};
            // Call Form Action sendEmail

            let readyToSubmit = true;

            Object?.keys(ctxFormSchema?.[apiName]?.schema)?.forEach((k: string) => {
               if (!ctxFormSchema?.[apiName]?.schema?.[k]) {
                  readyToSubmit = false;
               }
            })
            // debugger

            const mailResp: any = readyToSubmit ? await submitForm({
               emailBody: {
                  ...(Object?.keys(fValues)
                     .filter((key: string) => !["hCal"].includes(key))
                     .reduce((obj: any, key: string) => {
                        // if (["termsConsent", "privacyConsent", "marketingConsent"].includes(key)) {
                        //    console.log(fValues[key], Boolean(fValues[key]), "LetSee");
                        //    if (fValues[key] === 'on' ) { // on, string any, ""
                        //       obj[key] = true;
                        //    }else{
                        //       obj[key] = false;
                        //    }
                        // }
                        //  else {
                        //    obj[key] = fValues[key];
                        // }
                        if (key.includes("chk_")) {
                           const keyArr = key.split("chk_");  //["", "key"]
                           const newKey = keyArr[1];
                           if (fValues[key] === 'on' && Boolean(fValues[key])) { // on, string any, ""
                              obj[newKey] = true;
                           } else if (fValues[key] !== 'on' && Boolean(fValues[key])) {
                              obj[newKey] = fValues[key];
                           } else {
                              obj[newKey] = false;
                           }
                        } else {
                           obj[key] = fValues[key];
                        }
                        console.log(fValues[key], Boolean(fValues[key]), "aLetSee", obj);
                        return obj;
                     }, {})),
                  ...{
                     // emailPurpose: emailPurpose,
                     forwardingEmailSubject: props?.forwardingEmailSubject,
                     responseEmailSubject: props?.responseEmailSubject,
                     responseEmailTemplate: props?.responseEmailTemplate && documentToHtmlString(props?.responseEmailTemplate),
                     forwardingEmailTemplate: props?.forwardingEmailTemplate && documentToHtmlString(props?.forwardingEmailTemplate),
                     topImage: props?.topImage ? "https:" + props?.topImage : null,
                     bottomImage: props?.bottomImage ? "https:" + props?.bottomImage : null,
                     attachment: attachment ? (attachment?.includes("https:")) ? attachment : "https:" + attachment : null,
                  }
               }, messages: responseMessages
            })
               : { error: "confirmation" };

            // debugger;
            if (mailResp?.ok) {

               /* GTMdataLayer logic for succeesfull submit*/
               const frmGtmId = document.getElementById(formId)?.querySelector('form')?.id || id;
               sendEventToGTM({
                  event: 'form_submission',
                  pagePath: typeof window !== "undefined" ? window.location.pathname : "",
                  formId: frmGtmId,
                  formName: fValues?.api as string,
                  type: 'form',
                  ...Object.fromEntries(Object.entries(fValues).filter(([key]) => key.startsWith("chk_")).map(([key, value]) => [key.split("chk_")[1], ["yes", "y", "on", "true"].includes(value?.toString().toLowerCase())])),
                  subType: fValues?.api as string
               })
               // sessionStorage.removeItem(`${frmGtmId}_gtm_frm_flag`);
               if (gtmPushTimeout.current) {
                  clearTimeout(gtmPushTimeout.current);
               }
               // sessionStorage.removeItem(`${document.getElementById(formId)?.querySelector('form')?.id || id}_errorFormSubmission`);

               const successMessage = mailResp?.message
               setMessage({ text: successMessage, error: false });
               console.log("message ------ ", mailResp, mailResp?.message)

               if (typeof window !== "undefined") {
                  sessionStorage.removeItem(`${frmGtmId}_gtm_frm_flag`);
                  sessionStorage?.setItem(((id || `form_${formId}`) + "_form_status_success_message"), JSON.stringify(successMessage || {}));
                  if (!["development", "dev"].includes(NODE_ENV)) {
                     sessionStorage?.setItem(((id || `form_${formId}`) + "_form_status"), "Success"); // form test
                  }
                  window.location.hash = `#${formSuccessParam}`;
               }
               setSubmitted(false);
               setApiData(mailResp);

               // Store the booking reservation number in cookies for using it in automatic booking confirmation
               // const bookingId = mailResp?.expResp?.["json.data.reservation_id"];
               // const siteId = mailResp?.expResp?.["json.data.site_id"];
               // console.log("Booking ID and Site ID from form submission response: ", bookingId, siteId, mailResp);
               // if(bookingId && siteId) {
               //    addBookingReservationNumberToCookies({
               //       site_id: siteId as string,
               //       reservation_id: bookingId as string,
               //    });
               // }
            } else if (!mailResp?.error || (mailResp?.error && mailResp?.error !== "confirmation")) {
               const frmGtmId = document.getElementById(formId)?.querySelector('form')?.id || id;

               sendEventToGTM({
                  event: 'form_error',
                  subType: "api_error",
                  pagePath: typeof window !== "undefined" ? window.location.pathname : "",
                  formId: frmGtmId,
                  formName: fValues?.api as string,
                  type: 'form',
                  firstErrorMessage: typeof (mailResp?.error) === 'string' ? mailResp?.error : mailResp?.error?.message || responseMessages?.defaultError?.[locale] || responseMessages?.error?.[locale],
               })

               setMessage({ error: true, text: typeof (mailResp?.error) === 'string' ? mailResp?.error : mailResp?.error?.message || responseMessages?.defaultError?.[locale] || responseMessages?.error?.[locale] })
               setSubmitted(false);
            }
            if (readyToSubmit) {
               const newCount = count + 1;
               setCount(newCount);
               sessionStorage?.setItem(((id || `form_${formId}`) + "_form_status_count"), String(newCount));
            }
            else {
               scrollToFirstError();
               setSubmitted(false)
            }

            // setTimeout(() => {
            //    setMessage(null);
            // }, 10000);
         } else if (!resp?.success || count > 0) {
            setMessage({
               error: true, text: responseMessages?.multipleSubmit?.[locale] || "Invalid submission! You can't submit a form multiple times."
            });
            const newCount = count + 1;
            setCount(newCount);
            sessionStorage?.setItem(((id || `form_${formId}`) + "_form_status_count"), String(newCount));
            setSubmitted(false);
         } else {
            scrollToFirstError();
            setSubmitted(false);
         }

      } else {
         // setMessage({
         //    error: true, text: "You can't submit a blank form."
         // });
         scrollToFirstError();
         // return;
         setSubmitted(false);
      }
      if (typeof window !== "undefined") {
         setTimeout(() => {
            document?.getElementById("thankYouMsg")?.scrollIntoView({ behavior: "smooth", block: 'center', });
            document?.getElementById('formErrorMsg')?.scrollIntoView({ behavior: "smooth", block: 'center', });
         }, 500)
      }
   }

   useEffect(() => {
      if (customSuccessContent && message?.error === false) {
         const form = document?.getElementById(formId);
         const header = form?.querySelector("#formSuccessTitle");
         if (header) {
            header.textContent = message?.text?.title;
         }
         let body = form?.querySelector("#formSuccessBody")?.querySelector('p') ? form?.querySelector("#formSuccessBody")?.querySelector('p') : form?.querySelector("#formSuccessBody");
         if (body) {
            body.textContent = message?.text?.body;
         }
      }
   }, [message])

   const gtmDataLayerInvalidFormHandler = (e?: React.FormEvent<HTMLFormElement | null>) => {
      const target = e?.currentTarget;

      /* Clear any previous timeout 
         {timeout logic is for making sure, GTM data get pushed only once and when invalid bubble chain is completed.}
      */
      if (gtmPushTimeout.current) {
         clearTimeout(gtmPushTimeout.current);
      }
      gtmPushTimeout.current = setTimeout(() => {
         const invalidElements = target?.querySelectorAll(
            '.bp-form-error, [aria-invalid="true"], [data-error="true"]'
         ) as NodeListOf<Element> | undefined;
         // console.log(invalidElements?.[0], ctxFormSchema, ctxFormData, invalidElements?.[0]?.getAttribute('name'), Array.from(invalidElements || [])?.map((el)=>(el?.getAttribute('name'))), "invalidElementsinvalidElements");

         const sessionFrmFlag = JSON.parse(sessionStorage?.getItem(`${target?.id}_gtm_frm_flag`) || `{}`);
         if (!sessionFrmFlag?.frmError) {
            sendEventToGTM(
               {
                  event: 'form_error',
                  formId: target?.id,
                  formName: target?.name,
                  // location: 'modal',
                  pagePath: window.location.pathname,
                  type: 'form',
                  subType: 'validation error',
                  firstErrorField: invalidElements?.[0]?.getAttribute('name') as string,
                  // errorType: 'required',     // e.g., required, invalid_format, length_exceeded
                  firstErrorMessage: document.querySelector("p.text-input-error-message")?.innerHTML,
                  errorFields: Array.from(invalidElements || [])?.map((el) => (el?.getAttribute('name'))),
                  errorStepCount: invalidElements?.length
               }
            );
            sessionStorage?.setItem(`${target?.id}_gtm_frm_flag`, JSON.stringify({ ...sessionFrmFlag, "frmError": 1 }));
         }
      }, 0);
   }

   const isInContentfulStudio = (typeof window !== "undefined") && window.self !== window.top;

   return (
      <>
         <div style={{ display: "none" }}>API data :----- <pre>{JSON.stringify(apiData, null, 2)}</pre></div>
         <div data-testid="Form" id={formId} className={classNames(
            // "border-1 border-solid",
            // "relative",
            "w-auto",
            "h-auto",
            "min-w-[200px]",
            // "min-h-[80px]",
            { "overflow-y-auto": scroll }
         )}
            style={{ minHeight: props?.minHeight }}
         // {...inspectorModeProps({ fieldId: elData?.contentType || "baseplateForm", entryId: elData?.id })}
         >

            {/* {formContent} */}
            {
               submitted &&
               <Spinner skipTimer={true} className="bg-spinner-form" loading={submitted} loadingText="Submitting..." fullPage={false} />
            }
            {(message?.error === false && !["development", "dev"].includes(NODE_ENV)) ?
               <Box id={"thankYouMsg"} column hAlignContent="center" vAlignContent="center" className="w-full ">
                  {
                     customSuccessContent ? successContent : <>
                        <Heading size="l" fontStyle="livelyHeadline">{message?.text?.title || "Thank you!"}</Heading>
                        <Body size="m" id="success-submit-message" className="pt-2 px-6 text-center max-w-[375px]">
                           {message?.text?.body || "Thank you for your submission!"}
                        </Body></>
                  }
               </Box>
               :
               <>
                  {/* {(message?.error === false && ["development", "dev"].includes(NODE_ENV)) && 
                     <Box id={"thankYouMsg"} column hAlignContent="center" vAlignContent="center" className="w-full ">
                        <Heading size="l" fontStyle="livelyHeadline">{message?.text?.title || 'Thank you!'}</Heading>
                        <Body size="m" id="success-submit-message" className="pt-2 px-6 text-center max-w-[375px]">
                           {message?.text?.body || 'Thank you for your submission!'}
                        </Body>
                     </Box>
                  } */}
                  <StyledForm id={id || `form-${formId}`} name={apiName} className={
                     classNames(
                        "bp-col FormWrapper",
                        "!pt-form-padding-top",
                        "!pl-form-padding-left",
                        "!pb-form-padding-bottom",
                        "!pr-form-padding-right",
                        "!w-form-width",
                        "bg-interactive-dynamic-form",
                        "rounded-dynamic-form",
                        className,
                     )}
                     onSubmit={(e) => { handleSubmit(e) }}
                     onInvalid={(e) => { scrollToFirstError(); gtmDataLayerInvalidFormHandler(e); }}
                     // noValidate 
                     style={{ ...setPropsStyle(props), display: submitted ? "none" : "block" }}
                  // style={setPropsStyle(props)}
                  >
                     {/* ------ Honeypot ------ */}
                     {/* <input className="h-lastName" type="text" id="h-lastName" name="hLastName" placeholder="Your last name here" /> */}
                     <input type="hidden" id="api" name="api" value={apiName} />
                     <input type="hidden" id="h-cal" name="hCal" />
                     <input type="hidden" id="language" name="language" value={locale} />
                     {/* ---------------------- */}

                     {/* ------ Droppable elements area ------ */}
                     {formContent}

                     {/* <button className="btn btn-default" type="submit">Submit</button> */}
                     {message &&
                        <p id='formErrorMsg' className={
                           classNames(
                              "mt-4 text-center p-3",
                              {
                                 "text-interactive-dynamic-form-success-msg": !message?.error,
                                 "text-interactive-dynamic-form-error-msg": message?.error
                              }
                           )
                        }
                        // style={{ color: message?.error ? "var(--bp-colors-interactive-dynamic-form-error-msg)" : "var(--bp-colors-interactive-dynamic-form-success-msg)" }}
                        >
                           {typeof message?.text === "string"
                              ? message?.text
                              : (message?.text?.body || message?.text?.title || "")}
                        </p>
                     }
                  </StyledForm>
                  {customSuccessContent && isInContentfulStudio && successContent}
               </>
            }
            {/* <pre>Submit Count: {count}</pre> */}
            {/* <pre>{JSON.stringify(formData, null, 2)}</pre> */}
         </div>
      </>
   )
}

export default Form;